<template>
  <div class="page page-contact pt-20 pb-20 lines-bg lg:pt-40">
    <div
      class="max-w-2xl px-6 pb-12 mx-auto text-center opacity-0 lg:pb-16 contact-us-details"
      v-if="children.length > 0"
      v-animate-onscroll="'animated fadeIn'"
    >
      <page-sections v-if="children.length > 0" :sections="children" />
      <body-copy :content="body" class="contact-us-body" />
    </div>
    <FormstackIframe source="https://pleinairagency.formstack.com/forms/me_contact_us" />
    <!-- <contact-form
      :formData="fields"
      formName="Web Contact"
      sendKey="Help With"
      :content="{ heading: 'You have questions. We have answers.' }"
    /> -->
  </div>
</template>

<script>
import ContactForm from "~/components/common/ContactForm";
const contactFields = require("~/assets/config/contactUsForm.json");
import ContactSchema from "~/assets/src/contact-schema.json";
import PageSections from "~/components/PageSections";
import BodyCopy from "~/components/common/BodyCopy";
import FormstackIframe from "~/components/common/FormstackIframe";

export default {
  components: {
    ContactForm,
    PageSections,
    BodyCopy,
    FormstackIframe
  },
  async asyncData({ $api }) {
    return {
      page: await $api.getPage("contact-us")
    };
  },
  data() {
    return {
      fields: contactFields,
      script: [
        {
          type: "application/ld+json",
          json: ContactSchema
        }
      ]
    };
  },
  head() {
    return this.$metadata(this.page);
  },
  computed: {
    body() {
      return this.page.fields.body ? this.page.fields.body.content : [];
    },
    children() {
      return this.page.fields.children ? this.page.fields.children : [];
    }
  }
};
</script>
<style lang="scss">
.page-contact {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.contact-us-details {
  .details-section {
    @apply pb-6;
  }
  .contact-us-body {
    p {
      a {
        @apply text-purple;
        @apply font-semibold;
        @apply transition-all;
        @apply duration-200;

        &:hover {
          @apply text-pc-pink;
        }
      }
    }
  }
}
</style>
